import { useParams } from "react-router-dom/cjs/react-router-dom";
import logo from "../assets/images/new_ss_logo.png";
import { useEffect, useState } from "react";
import SimResultService from "../services/SimResultService";
import LoaderComponent from "./loader";
import { vi } from "date-fns/locale";

const Transcript = () => {
  const [videoTranscript, setVideoTranscript] = useState(null);
  const [loading, setLoading] = useState(false);
  const [header, setHeader] = useState("");

  const { key } = useParams();

  const transcriptText = async () => {
    setLoading(true);
    await SimResultService()
      .getVideoTranscript(key)
      .then((response) => {
        if (response.status === 200) {
          setVideoTranscript(response.data);
          if (response.data === "") {
            setHeader("Transcript is empty.");
          } else {
            setHeader("Video Transcript");
          }
          setLoading(false);
        } else {
          console.error("Error fetching transcript:", response.message);
          setHeader(
            "The transcript you requested may have been deleted. Please contact the administrator."
          );
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    transcriptText();
  }, [key]);

  return (
    <>
      <div className="col-8 offset-2 text-center">
        <img src={logo} alt="SchoolSims Logo" className="logo" />
        <h3>{header}</h3>
        {videoTranscript !== null && <p>{videoTranscript}</p>}
      </div>
      {loading && (
        <div className="overlay">
          <LoaderComponent />
        </div>
      )}
    </>
  );
};

export default Transcript;
